var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('object',{ref:"chart"},[_c('div',{attrs:{"id":"taskCommentsPie"}})])}
var staticRenderFns = []

export { render, staticRenderFns }